<template>
  <div class="flex">
    <div
      class="group relative flex p-15 md:p-20 items-center rounded-6 md:transition-color md:duration-300 text-app-color cursor-pointer"
      :class="classes"
      @click="goToHeadquarters"
    >
      <div v-if="teamLogo" class="max-h-70 max-w-100 h-full w-full flex-shrink-0">
        <img
          class="w-full h-full rounded-6 object-contain p-5"
          :class="isBookInstructionAccepted ? 'bg-canvas' : 'bg-transparent'"
          :src="teamLogo"
          alt="teamLogo"
        >
      </div>

      <div
        v-else
        class="p-10 w-full max-w-100 h-60 rounded-6 flex items-center justify-center flex-shrink-0"
        :class="isBookInstructionAccepted ? 'bg-white' : 'bg-transparent'"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="216" height="63" viewBox="0 0 216 63" fill="none">
          <path d="M74.54 29.632C71.956 29.632 70.132 31.076 69.296 32.444V22.526H64.052V50H69.296V38.068C69.296 35.94 70.702 34.344 72.906 34.344C74.692 34.344 76.212 35.712 76.212 37.916V50H81.418V38.524C81.418 34.306 80.24 29.632 74.54 29.632ZM84.3259 40.12C84.3259 46.086 88.3919 50.494 94.7759 50.494C99.7159 50.494 102.376 47.53 103.136 46.124L99.6779 43.502C99.1079 44.338 97.5499 45.934 94.8519 45.934C91.9259 45.934 89.7979 44.034 89.6839 41.374H103.668C103.706 40.994 103.706 40.614 103.706 40.234C103.706 33.736 100.21 29.632 94.0539 29.632C88.3919 29.632 84.3259 34.116 84.3259 40.12ZM89.8359 37.954C90.0639 35.674 91.6599 33.926 94.1299 33.926C96.5239 33.926 98.2719 35.522 98.3859 37.954H89.8359ZM106.616 50H111.86V22.526H106.616V50ZM116.005 50H121.249V22.526H116.005V50ZM124.292 40.12C124.292 46.124 128.776 50.494 134.97 50.494C141.202 50.494 145.686 46.124 145.686 40.12C145.686 34.116 141.05 29.632 134.97 29.632C128.928 29.632 124.292 34.078 124.292 40.12ZM129.536 40.12C129.536 36.7 131.816 34.268 134.97 34.268C138.124 34.268 140.442 36.738 140.442 40.12C140.442 43.502 138.124 45.858 134.97 45.858C131.854 45.858 129.536 43.502 129.536 40.12ZM158.124 50H163.368V30.126H158.124V50ZM157.668 25.338C157.668 27.048 158.998 28.34 160.708 28.34C162.456 28.34 163.786 27.048 163.786 25.338C163.786 23.628 162.456 22.336 160.708 22.336C158.998 22.336 157.668 23.628 157.668 25.338ZM178.799 50L185.905 30.126H180.319L175.759 44.414L171.199 30.126H165.613L172.719 50H178.799ZM197.315 56.802L207.461 30.126H201.989L197.505 43.084L193.059 30.126H187.435L195.073 49.506L192.299 56.802H197.315ZM210.472 50.494C212.296 50.494 213.702 49.05 213.702 47.302C213.702 45.516 212.296 44.034 210.472 44.034C208.648 44.034 207.242 45.516 207.242 47.302C207.242 49.05 208.648 50.494 210.472 50.494Z" fill="url(#paint0_linear)" />
          <path d="M10.7433 31.5594C11.9929 23.2602 15.2696 0.271896 18.3797 2.10344C22.2674 4.39288 16.3665 27.2667 18.3797 30.0331C20.393 32.7995 23.9485 10.7637 27.9056 8.95124C31.8627 7.13878 25.9468 33.8489 24.9055 35.089C23.8642 36.3291 37.3259 14.8068 37.9507 20.2442C38.3994 24.1489 34.0758 35.3625 31.6295 40.8828C31.3862 41.4317 31.2646 41.7061 31.318 41.7635C31.333 41.7796 31.3516 41.7909 31.3728 41.7969C31.4482 41.8181 31.6356 41.5856 32.0103 41.1206C35.712 36.5267 43.8874 26.5733 45.9471 28.4601C48.3422 30.6541 34.2499 60.8557 20.709 60.8557C5.79244 60.8557 3.58854 37.0198 2.41513 31.5594C-0.609936 17.4826 13.8898 31.6261 13.8898 40.45" stroke="url(#paint1_linear)" stroke-width="2.96822" stroke-linecap="round" stroke-linejoin="round" />
          <defs>
            <linearGradient id="paint0_linear" x1="39.5417" y1="16.7778" x2="277.569" y2="84.3672" gradientUnits="userSpaceOnUse">
              <stop stop-color="#A109FF" />
              <stop offset="1" stop-color="#DA42CB" />
            </linearGradient>
            <linearGradient id="paint1_linear" x1="-6.5" y1="47.5" x2="89" y2="20" gradientUnits="userSpaceOnUse">
              <stop stop-color="#A109FF" />
              <stop offset="1" stop-color="#DA42CB" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      <div class="ml-15 md:ml-20 pb-15 pr-10">
        <p class="text-20 font-bold">Headquarters</p>
        <p class="text-13 md:text-14 opacity-70 group-hover:opacity-100 anim-opacity leading-tight"
           :class="isDarkMode ? 'text-grey-250' : 'text-grey-1000'"
        >
          Your team's home. Announcements <br class="hidden md:block"> and company-wide chatter.
        </p>
      </div>
      <div
        class="absolute bottom-5 text-grey-250 right-5 flex opacity-70 group-hover:opacity-100 anim-opacity text-14 py-5 px-10 rounded-8"
        :class="membersClasses"
        @click.stop="showDropdown = !showDropdown"
      >
        <i class="icon-supervisor-account text-20 mr-2" /> {{ members?.length }}
      </div>
      <HeadquartersMembersModal
        v-if="showDropdown"
        class="absolute top-120 right-5"
        :members="members"
        @show-dropdown="showDropdown = $event"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import HeadquartersMembersModal from '@/components/books/HeadquartersMembersModal'

export default defineComponent({
  components: { HeadquartersMembersModal },

  setup () {
    const { state, getters, dispatch } = useStore()
    const router = useRouter()

    dispatch('getMembers', {
      limit: 100
    })

    const team = computed(() => state.team.team)
    const headquarters = computed(() => state.team.headquarters)
    const teamLogo = computed(() => team.value?.teamLogo?.url)
    const isBookInstructionAccepted = computed(() => getters.isBookInstructionAccepted)
    const isDarkMode = computed(() => getters.isDarkMode)
    const members = computed(() => state.team.members)

    const showDropdown = ref(false)

    const classes = computed(() => {
      const prefix = showDropdown.value ? '' : 'hover:'
      const shadow = isDarkMode.value ? '' : `shadow-book ${prefix}shadow-book-hover `
      const bg = isDarkMode.value ? `bg-book ${prefix}bg-hover-book` : 'bg-white'

      return (!isBookInstructionAccepted.value ? 'border-3 border-link-color ' : shadow) + bg
    })

    const membersClasses = computed(() => {
      if (isDarkMode.value) {
        return showDropdown.value ? 'bg-sidebar opacity-100' : 'hover:bg-sidebar'
      } else {
        return showDropdown.value ? 'bg-project opacity-100' : 'hover:bg-project'
      }
    })

    function goToHeadquarters () {
      router.push({ name: 'Headquarters', params: { team: team.value.link, id: headquarters.value.id } })
    }

    return {
      classes,
      members,
      teamLogo,
      isDarkMode,
      showDropdown,
      membersClasses,
      isBookInstructionAccepted,
      goToHeadquarters
    }
  }

})
</script>
